import type { MeResponse, RuleInput } from '@alerts/shared'
import { getTg } from './tg'

function headers(): HeadersInit {
  const initData = getTg()?.initData ?? ''
  return { 'content-type': 'application/json', 'x-tg-init-data': initData }
}

async function handle<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(`API ${res.status}: ${text}`)
  }
  return (await res.json()) as T
}

export const api = {
  me: async (): Promise<MeResponse> => handle(await fetch('/api/me', { headers: headers() })),
  saveRule: async (rule: RuleInput) =>
    handle<{ ok: true }>(
      await fetch('/api/rules', { method: 'PUT', headers: headers(), body: JSON.stringify(rule) }),
    ),
  deleteRule: async (market: string) =>
    handle<{ ok: true }>(await fetch(`/api/rules/${market}`, { method: 'DELETE', headers: headers() })),
  setRuleEnabled: async (market: string, enabled: boolean) =>
    handle<{ ok: true }>(
      await fetch(`/api/rules/${market}/enabled`, {
        method: 'PATCH',
        headers: headers(),
        body: JSON.stringify({ enabled }),
      }),
    ),
}
